import {
  LIVE_TRACKER_ANALYTICS_DATA_LOADED,
  LIVE_TRACKER_ANALYTICS_DATA_CLEAR,
  WATERMARK_DETECTIONS_LOADED,
  WATERMARK_DETECTIONS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import { arriveNotice } from '../noticeActions';
import {
  setSecondaryFetchLoaderLoading,
  setSecondaryFetchLoaderReset,
} from '../fetchLoaderActions';
import { setFaviconLoading, setFaviconDefault } from '../faviconActions';

// Reducer corresponding actions
function liveTrackerAnalyticsDataLoaded(analyticsData) {
  return {
    type: LIVE_TRACKER_ANALYTICS_DATA_LOADED,
    payload: { analyticsData },
  };
}

function liveTrackerAnalyticsDataClear() {
  return { type: LIVE_TRACKER_ANALYTICS_DATA_CLEAR };
}

// API
async function getLiveTrackerAnalyticsApi(token, params) {
  const response = await api.get({
    path: 'companies/ip-and-traffic',
    token,
    params,
    version: 'gateway',
  });
  return response.json();
}

// Helper
async function fetchLiveTrackerAnalytics(dispatch, token, params) {
  try {
    const analyticsData = await getLiveTrackerAnalyticsApi(token, params);
    dispatch(liveTrackerAnalyticsDataLoaded(api.camelizeKeys(analyticsData)));
  } catch (e) {
    if (e.name !== 'AbortError') {
      dispatch(arriveNotice('Unable to load hosting data. Please try again later.'));
    }
  } finally {
    dispatch(setFaviconDefault());
    dispatch(setSecondaryFetchLoaderReset());
  }
}

// Public component actions
export function initiateLiveTrackerAnalyticsRequest(params) {
  return async (dispatch, getState) => {
    const {
      auth: { token },
      favicon: { faviconStatus },
      fetchLoader: { dataLoading },
    } = getState();

    if (!dataLoading) {
      dispatch(setSecondaryFetchLoaderLoading());
    }

    if (faviconStatus !== 'loading') {
      dispatch(setFaviconLoading());
    }

    await fetchLiveTrackerAnalytics(dispatch, token, params);
  };
}

export function clearLiveTrackerAnalyticsRequest() {
  return (dispatch) => {
    dispatch(liveTrackerAnalyticsDataClear());
  };
}

// Watermark Detections
function watermarkDetectionsLoaded(data) {
  return {
    type: WATERMARK_DETECTIONS_LOADED,
    payload: { data },
  };
}

function watermarkDetectionsClear() {
  return { type: WATERMARK_DETECTIONS_CLEAR };
}

async function getWatermarkDetectionsApi(token) {
  const response = await api.get({
    path: 'results/watermark-detections',
    token,
    version: 'gateway',
  });
  return response.json();
}

export function initiateWatermarkDetectionsRequest() {
  return async (dispatch, getState) => {
    const { auth: { token } } = getState();
    try {
      const data = await getWatermarkDetectionsApi(token);
      dispatch(watermarkDetectionsLoaded(data));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function clearWatermarkDetectionsRequest() {
  return (dispatch) => {
    dispatch(watermarkDetectionsClear());
  };
}
